<app-team-member-info 
    (submitTeamMember)="onSubmit($event)"
    [organizationList]="organizationList"
    [orgId]="selectedOrg"
    [submittingAndAdding]="loading"
>
    <ng-container title> Add Team Member </ng-container>
</app-team-member-info>
